import { render, staticRenderFns } from "./NotificationTemplateEditor.vue?vue&type=template&id=72406403&scoped=true&"
import script from "./NotificationTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTemplateEditor.vue?vue&type=style&index=0&id=72406403&scoped=true&lang=css&"
import style1 from "./NotificationTemplateEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72406403",
  null
  
)

export default component.exports